"use strict";
/*
A place for enums that may be used across models and aren't owned by any
 particular model.
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustryTypeEnum = exports.SchoolJobTitleEnum = exports.OrganizationSizeEnum = exports.TShirtSize = exports.OrganisationIdTypes = exports.FundraisingSegments = exports.FundraisingSegmentsPublic = exports.FundraisingSegmentsSchool = exports.FundraisingSegmentsWork = exports.Campaigns = exports.FundraisingActivities = exports.FundraisingTools = exports.Sources = exports.FundraisingGroups = void 0;
/**
 * These are the groups used for the segmentation of fundraisers.
 */
var FundraisingGroups;
(function (FundraisingGroups) {
    FundraisingGroups["SCHOOL"] = "school";
    FundraisingGroups["WORK"] = "work";
    FundraisingGroups["PUBLIC"] = "public";
    // todo: support corporate partners
    // CORPORATE_PARTNER = 'corporate_partner',
})(FundraisingGroups = exports.FundraisingGroups || (exports.FundraisingGroups = {}));
/**
 * Values for source/transSource properties, which are used to indicate the
 *  source of a record (e.g. which service / product / platform it came from)
 */
var Sources;
(function (Sources) {
    Sources["FUNDRAISER_SIGNUP"] = "fundraiser_signup";
    Sources["CR_SITE"] = "CRSite";
    Sources["SR_SITE"] = "SRSite";
    Sources["PSL_PAYIN"] = "psl_payin";
    // todo: add other permitted options for source/transSource columns.
})(Sources = exports.Sources || (exports.Sources = {}));
/**
 * These are the different services or 'tools' that are offered to fundraisers
 *  during the fundraiser signup journey.
 */
var FundraisingTools;
(function (FundraisingTools) {
    /**
     * If they select this, we will attempt to generate a JustGiving page for
     *  them.
     */
    FundraisingTools["JUSTGIVING_PAGE"] = "justgiving_page_setup";
    /**
     * If this is chosen, we will send them them a physical fundraising pack.
     */
    FundraisingTools["FUNDRAISING_PACK"] = "fundraising_pack";
    /**
     * We will email a digital fundraising pack (or a link to one)
     */
    FundraisingTools["DIGITAL_PACK"] = "digital_pack";
    /**
     * We will email a link to other downloadable resources.
     */
    FundraisingTools["DOWNLOADABLE_TOOLS"] = "downloadable_tools";
})(FundraisingTools = exports.FundraisingTools || (exports.FundraisingTools = {}));
/**
 * The different types of fundraising that fundraisers might undertake.
 */
var FundraisingActivities;
(function (FundraisingActivities) {
    // RND
    FundraisingActivities["FANCY_DRESS"] = "fancy_dress";
    FundraisingActivities["BAKING"] = "baking";
    FundraisingActivities["SPONSORED_CHALLENGE"] = "sponsored_challenge";
    FundraisingActivities["QUIZ_OR_GAMES"] = "quiz_or_games";
    FundraisingActivities["TALENT_SHOW"] = "talent_show";
    FundraisingActivities["SPORT_ACTIVITY"] = "sport_activity";
    // SRCW
    FundraisingActivities["RUN"] = "run";
    FundraisingActivities["WALK"] = "walk";
    FundraisingActivities["CYCLE"] = "cycle";
    FundraisingActivities["SWIM"] = "swim";
    FundraisingActivities["A_COMBINATION"] = "a_combination";
    // common
    FundraisingActivities["SOMETHING_ELSE"] = "something_else";
    FundraisingActivities["NOT_SURE_YET"] = "not_sure_yet";
})(FundraisingActivities = exports.FundraisingActivities || (exports.FundraisingActivities = {}));
/**
 * Campaigns
 */
var Campaigns;
(function (Campaigns) {
    /** Comic Relief year-round activity */
    Campaigns["CR"] = "CR";
    /** Year-round General (used on donations; not sure how this differs from `CR`) */
    Campaigns["YRG"] = "YRG";
    /** Red Nose Day 2017 */
    Campaigns["RND17"] = "RND17";
    /** Sport Relief 2018 */
    Campaigns["SR18"] = "SR18";
    /** Red Nose Day 2019 */
    Campaigns["RND19"] = "RND19";
    /** Sport Relief 2020 */
    Campaigns["SR20"] = "SR20";
    /** Big Night In "COVID Relief" (note that this happened after SR20) */
    Campaigns["CV19"] = "CV19";
    /** Red Nose Day 2021 */
    Campaigns["RND21"] = "RND21";
    /** Red Nose Day 2022 */
    Campaigns["RND22"] = "RND22";
    /** Sport Relief Commonwealth Games 2022 */
    Campaigns["SRCW22"] = "SRCW22";
    /** Red Nose Day 2023 */
    Campaigns["RND23"] = "RND23";
    /** Winter Campaign 2022 */
    Campaigns["YRW"] = "YRW";
    /** Winter Appeal 2023 */
    Campaigns["YW23"] = "YW23";
    /** Red Nose Day 2024 */
    Campaigns["RND24"] = "RND24";
    /** Sport Relief Summer 2024 */
    Campaigns["SR24"] = "SR24";
    /** Red Nose Day 2025 */
    Campaigns["RND25"] = "RND25";
    /** Winter Appeal 2024 */
    Campaigns["YW24"] = "YW24";
})(Campaigns = exports.Campaigns || (exports.Campaigns = {}));
var FundraisingSegmentsWork;
(function (FundraisingSegmentsWork) {
    FundraisingSegmentsWork["WORK"] = "work";
})(FundraisingSegmentsWork = exports.FundraisingSegmentsWork || (exports.FundraisingSegmentsWork = {}));
var FundraisingSegmentsSchool;
(function (FundraisingSegmentsSchool) {
    FundraisingSegmentsSchool["NURSERY"] = "nursery";
    FundraisingSegmentsSchool["PRIMARY"] = "primary_school";
    FundraisingSegmentsSchool["SECONDARY"] = "secondary_school";
    FundraisingSegmentsSchool["SIXTH_FORM_COLLEGE"] = "sixth_form_college";
    FundraisingSegmentsSchool["YOUTH_GROUP"] = "youth_group";
    FundraisingSegmentsSchool["OTHER"] = "school_other";
    // "one-off" segments for SR24
    FundraisingSegmentsSchool["SCHOOL_SPORTS_CLUB"] = "school_sports_club";
    FundraisingSegmentsSchool["SCHOOL_PARENT_OR_CARER"] = "school_parent_or_carer";
    // generic option if no specific value known.
    FundraisingSegmentsSchool["SCHOOL"] = "school";
})(FundraisingSegmentsSchool = exports.FundraisingSegmentsSchool || (exports.FundraisingSegmentsSchool = {}));
var FundraisingSegmentsPublic;
(function (FundraisingSegmentsPublic) {
    FundraisingSegmentsPublic["INDIVIDUAL"] = "individual";
    FundraisingSegmentsPublic["SPORTS_CLUB"] = "sports_club";
    FundraisingSegmentsPublic["RELIGIOUS_GROUP"] = "religious_group";
    FundraisingSegmentsPublic["COMMUNITY_GROUP"] = "community_group";
    FundraisingSegmentsPublic["UNIVERSITY"] = "university";
    FundraisingSegmentsPublic["FRIENDS_OR_FAMILY"] = "friends_or_family";
    FundraisingSegmentsPublic["PUBLIC_OTHER"] = "public_other";
    // generic option if no specific value known.
    FundraisingSegmentsPublic["PUBLIC"] = "public";
})(FundraisingSegmentsPublic = exports.FundraisingSegmentsPublic || (exports.FundraisingSegmentsPublic = {}));
exports.FundraisingSegments = __assign(__assign(__assign({}, FundraisingSegmentsWork), FundraisingSegmentsSchool), FundraisingSegmentsPublic);
var OrganisationIdTypes;
(function (OrganisationIdTypes) {
    OrganisationIdTypes["EDCO"] = "edco";
    OrganisationIdTypes["CROSL"] = "crosl";
})(OrganisationIdTypes = exports.OrganisationIdTypes || (exports.OrganisationIdTypes = {}));
var TShirtSize;
(function (TShirtSize) {
    TShirtSize["NONE"] = "none";
    TShirtSize["EXTRA_SMALL"] = "XS";
    TShirtSize["SMALL"] = "S";
    TShirtSize["MEDIUM"] = "M";
    TShirtSize["LARGE"] = "L";
    TShirtSize["EXTRA_LARGE"] = "XL";
})(TShirtSize = exports.TShirtSize || (exports.TShirtSize = {}));
var OrganizationSizeEnum;
(function (OrganizationSizeEnum) {
    OrganizationSizeEnum["UnderFifty"] = "Under 50";
    OrganizationSizeEnum["FiftyToOneHundred"] = "50-100";
    OrganizationSizeEnum["OneHundredToTwoHundred"] = "100-200";
    OrganizationSizeEnum["OverTwoHundred"] = "Over 200";
})(OrganizationSizeEnum = exports.OrganizationSizeEnum || (exports.OrganizationSizeEnum = {}));
var SchoolJobTitleEnum;
(function (SchoolJobTitleEnum) {
    SchoolJobTitleEnum["AdministrativeStaff"] = "Administrative Staff";
    SchoolJobTitleEnum["AssistantHead"] = "Assistant Head";
    SchoolJobTitleEnum["BusinessManagement"] = "Business Management";
    SchoolJobTitleEnum["CharityCoordinator"] = "Charity Coordinator";
    SchoolJobTitleEnum["Childminder"] = "Childminder";
    SchoolJobTitleEnum["DeputyHead"] = "Deputy Head";
    SchoolJobTitleEnum["EarlyYearsPractitioner"] = "Early Years Practitioner";
    SchoolJobTitleEnum["HeadOfDepartment"] = "Head of Department";
    SchoolJobTitleEnum["HeadOfYear"] = "Head of Year";
    SchoolJobTitleEnum["HeadTeacher"] = "Head Teacher";
    SchoolJobTitleEnum["Manager"] = "Manager";
    SchoolJobTitleEnum["PECoordinator"] = "PE Coordinator";
    SchoolJobTitleEnum["PEDepartment"] = "PE Department";
    SchoolJobTitleEnum["PSHECoordinator"] = "PSHE Coordinator";
    SchoolJobTitleEnum["SENDepartment"] = "SEN Department";
    SchoolJobTitleEnum["Student"] = "Student";
    SchoolJobTitleEnum["SupportStaff"] = "Support Staff";
    SchoolJobTitleEnum["Teacher"] = "Teacher";
    SchoolJobTitleEnum["Other"] = "Other";
})(SchoolJobTitleEnum = exports.SchoolJobTitleEnum || (exports.SchoolJobTitleEnum = {}));
/*
Below Industry List Adapted from: https://github.com/teclone/industries

MIT License

Copyright (c) 2019 Harrison Ifeanyichukwu

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
var IndustryTypeEnum;
(function (IndustryTypeEnum) {
    IndustryTypeEnum["Accounting"] = "Accounting";
    IndustryTypeEnum["AirlinesAviation"] = "Airlines/Aviation";
    IndustryTypeEnum["AlternativeDisputeResolution"] = "Alternative Dispute Resolution";
    IndustryTypeEnum["AlternativeMedicine"] = "Alternative Medicine";
    IndustryTypeEnum["Animation"] = "Animation";
    IndustryTypeEnum["ApparelFashion"] = "Apparel & Fashion";
    IndustryTypeEnum["ArchitecturePlanning"] = "Architecture & Planning";
    IndustryTypeEnum["ArtsAndCrafts"] = "Arts and Crafts";
    IndustryTypeEnum["Automotive"] = "Automotive";
    IndustryTypeEnum["AviationAerospace"] = "Aviation and Aerospace";
    IndustryTypeEnum["Banking"] = "Banking";
    IndustryTypeEnum["Biotechnology"] = "Biotechnology";
    IndustryTypeEnum["BroadcastMedia"] = "Broadcast Media";
    IndustryTypeEnum["BuildingMaterials"] = "Building Materials";
    IndustryTypeEnum["BusinessSuppliesEquipment"] = "Business Supplies and Equipment";
    IndustryTypeEnum["CapitalMarkets"] = "Capital Markets";
    IndustryTypeEnum["Chemicals"] = "Chemicals";
    IndustryTypeEnum["CivicSocialOrganization"] = "Civic & Social Organization";
    IndustryTypeEnum["CivilEngineering"] = "Civil Engineering";
    IndustryTypeEnum["CommercialRealEstate"] = "Commercial Real Estate";
    IndustryTypeEnum["ComputerNetworkSecurity"] = "Computer & Network Security";
    IndustryTypeEnum["ComputerGames"] = "Computer Games";
    IndustryTypeEnum["ComputerHardware"] = "Computer Hardware";
    IndustryTypeEnum["ComputerNetworking"] = "Computer Networking";
    IndustryTypeEnum["ComputerSoftware"] = "Computer Software";
    IndustryTypeEnum["Construction"] = "Construction";
    IndustryTypeEnum["ConsumerElectronics"] = "Consumer Electronics";
    IndustryTypeEnum["ConsumerGoods"] = "Consumer Goods";
    IndustryTypeEnum["ConsumerServices"] = "Consumer Services";
    IndustryTypeEnum["Cosmetics"] = "Cosmetics";
    IndustryTypeEnum["Dairy"] = "Dairy";
    IndustryTypeEnum["DefenseSpace"] = "Defense & Space";
    IndustryTypeEnum["Design"] = "Design";
    IndustryTypeEnum["Elearning"] = "E-learning";
    IndustryTypeEnum["EducationManagement"] = "Education Management";
    IndustryTypeEnum["ElectricalElectronicManufacturing"] = "Electrical/Electronic Manufacturing";
    IndustryTypeEnum["Entertainment"] = "Entertainment";
    IndustryTypeEnum["EnvironmentalServices"] = "Environmental Services";
    IndustryTypeEnum["EventsServices"] = "Events Services";
    IndustryTypeEnum["ExecutiveOffice"] = "Executive Office";
    IndustryTypeEnum["FacilitiesServices"] = "Facilities Services";
    IndustryTypeEnum["Farming"] = "Farming";
    IndustryTypeEnum["FinancialServices"] = "Financial Services";
    IndustryTypeEnum["FineArt"] = "Fine Art";
    IndustryTypeEnum["Fishery"] = "Fishery";
    IndustryTypeEnum["FoodBeverages"] = "Food & Beverages";
    IndustryTypeEnum["FoodProduction"] = "Food Production";
    IndustryTypeEnum["FundRaising"] = "Fund-Raising";
    IndustryTypeEnum["Furniture"] = "Furniture";
    IndustryTypeEnum["GamblingCasinos"] = "Gambling & Casinos";
    IndustryTypeEnum["GlassCeramicsConcrete"] = "Glass, Ceramics & Concrete";
    IndustryTypeEnum["GovernmentAdministration"] = "Government Administration";
    IndustryTypeEnum["GovernmentRelations"] = "Government Relations";
    IndustryTypeEnum["GraphicDesign"] = "Graphic Design";
    IndustryTypeEnum["HealthWellnessFitness"] = "Health, Wellness and Fitness";
    IndustryTypeEnum["HigherEducation"] = "Higher Education";
    IndustryTypeEnum["HospitalHealthCare"] = "Hospital & Health Care";
    IndustryTypeEnum["Hospitality"] = "Hospitality";
    IndustryTypeEnum["HumanResources"] = "Human Resources";
    IndustryTypeEnum["ImportAndExport"] = "Import and Export";
    IndustryTypeEnum["IndividualFamilyServices"] = "Individual & Family Services";
    IndustryTypeEnum["IndustrialAutomation"] = "Industrial Automation";
    IndustryTypeEnum["InformationServices"] = "Information Services";
    IndustryTypeEnum["InformationTechnologyServices"] = "Information Technology and Services";
    IndustryTypeEnum["Insurance"] = "Insurance";
    IndustryTypeEnum["InternationalAffairs"] = "International Affairs";
    IndustryTypeEnum["InternationalTradeDevelopment"] = "International Trade and Development";
    IndustryTypeEnum["Internet"] = "Internet";
    IndustryTypeEnum["InvestmentBanking"] = "Investment Banking";
    IndustryTypeEnum["InvestmentManagement"] = "Investment Management";
    IndustryTypeEnum["Judiciary"] = "Judiciary";
    IndustryTypeEnum["LawEnforcement"] = "Law Enforcement";
    IndustryTypeEnum["LawPractice"] = "Law Practice";
    IndustryTypeEnum["LegalServices"] = "Legal Services";
    IndustryTypeEnum["LegislativeOffice"] = "Legislative Office";
    IndustryTypeEnum["LeisureTravelTourism"] = "Leisure, Travel & Tourism";
    IndustryTypeEnum["Libraries"] = "Libraries";
    IndustryTypeEnum["LogisticsSupplyChain"] = "Logistics and Supply Chain";
    IndustryTypeEnum["LuxuryGoodsJewelry"] = "Luxury Goods & Jewelry";
    IndustryTypeEnum["Machinery"] = "Machinery";
    IndustryTypeEnum["ManagementConsulting"] = "Management Consulting";
    IndustryTypeEnum["Maritime"] = "Maritime";
    IndustryTypeEnum["MarketResearch"] = "Market Research";
    IndustryTypeEnum["MarketingAdvertising"] = "Marketing and Advertising";
    IndustryTypeEnum["MechanicalIndustrialEngineering"] = "Mechanical or Industrial Engineering";
    IndustryTypeEnum["MediaProduction"] = "Media Production";
    IndustryTypeEnum["MedicalDevices"] = "Medical Devices";
    IndustryTypeEnum["MedicalPractice"] = "Medical Practice";
    IndustryTypeEnum["MentalHealthCare"] = "Mental Health Care";
    IndustryTypeEnum["Military"] = "Military";
    IndustryTypeEnum["MiningMetals"] = "Mining & Metals";
    IndustryTypeEnum["MotionPicturesFilm"] = "Motion Pictures and Film";
    IndustryTypeEnum["MuseumsInstitutions"] = "Museums and Institutions";
    IndustryTypeEnum["Music"] = "Music";
    IndustryTypeEnum["Nanotechnology"] = "Nanotechnology";
    IndustryTypeEnum["Newspapers"] = "Newspapers";
    IndustryTypeEnum["NonProfitOrganizationManagement"] = "Non-Profit Organization Management";
    IndustryTypeEnum["OilEnergy"] = "Oil & Energy";
    IndustryTypeEnum["OnlineMedia"] = "Online Media";
    IndustryTypeEnum["OutsourcingOffshoring"] = "Outsourcing/Offshoring";
    IndustryTypeEnum["PackageFreightDelivery"] = "Package/Freight Delivery";
    IndustryTypeEnum["PackagingContainers"] = "Packaging and Containers";
    IndustryTypeEnum["PaperForestProducts"] = "Paper & Forest Products";
    IndustryTypeEnum["PerformingArts"] = "Performing Arts";
    IndustryTypeEnum["Pharmaceuticals"] = "Pharmaceuticals";
    IndustryTypeEnum["Philanthropy"] = "Philanthropy";
    IndustryTypeEnum["Photography"] = "Photography";
    IndustryTypeEnum["Plastics"] = "Plastics";
    IndustryTypeEnum["PoliticalOrganization"] = "Political Organization";
    IndustryTypeEnum["PrimarySecondaryEducation"] = "Primary/Secondary Education";
    IndustryTypeEnum["Printing"] = "Printing";
    IndustryTypeEnum["ProfessionalTrainingCoaching"] = "Professional Training & Coaching";
    IndustryTypeEnum["ProgramDevelopment"] = "Program Development";
    IndustryTypeEnum["PublicPolicy"] = "Public Policy";
    IndustryTypeEnum["PublicRelationsCommunications"] = "Public Relations and Communications";
    IndustryTypeEnum["PublicSafety"] = "Public Safety";
    IndustryTypeEnum["Publishing"] = "Publishing";
    IndustryTypeEnum["RailroadManufacture"] = "Railroad Manufacture";
    IndustryTypeEnum["Ranching"] = "Ranching";
    IndustryTypeEnum["RealEstate"] = "Real Estate";
    IndustryTypeEnum["RecreationalFacilitiesServices"] = "Recreational Facilities and Services";
    IndustryTypeEnum["ReligiousInstitutions"] = "Religious Institutions";
    IndustryTypeEnum["RenewablesEnvironment"] = "Renewables & Environment";
    IndustryTypeEnum["Research"] = "Research";
    IndustryTypeEnum["Restaurants"] = "Restaurants";
    IndustryTypeEnum["Retail"] = "Retail";
    IndustryTypeEnum["SecurityInvestigations"] = "Security and Investigations";
    IndustryTypeEnum["Semiconductors"] = "Semiconductors";
    IndustryTypeEnum["ShipBuilding"] = "Ship Building";
    IndustryTypeEnum["SportingGoods"] = "Sporting Goods";
    IndustryTypeEnum["Sports"] = "Sports";
    IndustryTypeEnum["StaffingRecruiting"] = "Staffing and Recruiting";
    IndustryTypeEnum["Supermarkets"] = "Supermarkets";
    IndustryTypeEnum["Telecommunications"] = "Telecommunications";
    IndustryTypeEnum["Textiles"] = "Textiles";
    IndustryTypeEnum["ThinkTanks"] = "Think Tanks";
    IndustryTypeEnum["Tobacco"] = "Tobacco";
    IndustryTypeEnum["TranslationLocalization"] = "Translation and Localization";
    IndustryTypeEnum["TransportationTruckingRailroad"] = "Transportation/Trucking/Railroad";
    IndustryTypeEnum["Utilities"] = "Utilities";
    IndustryTypeEnum["VentureCapitalPrivateEquity"] = "Venture Capital & Private Equity";
    IndustryTypeEnum["Veterinary"] = "Veterinary";
    IndustryTypeEnum["Warehousing"] = "Warehousing";
    IndustryTypeEnum["Wholesale"] = "Wholesale";
    IndustryTypeEnum["WineSpirits"] = "Wine and Spirits";
    IndustryTypeEnum["Wireless"] = "Wireless";
    IndustryTypeEnum["WritingEditing"] = "Writing and Editing";
})(IndustryTypeEnum = exports.IndustryTypeEnum || (exports.IndustryTypeEnum = {}));
//# sourceMappingURL=enums.js.map